import { LoginService } from './../login/login.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DataTypeMapper } from 'src/app/models/datatype/data-type.mapper';
import { DataTypeItem, DatatypeTreeHierarchi } from 'src/app/models/datatype/datatype-hierarchi.model';
import { DataGroup } from "src/app/models/datatype/DataGroup";
import { map } from 'rxjs/operators';
import { DataTypeAggregateGraphQlResponse, DataTypeGroupGraphQlResponse } from 'src/app/models/graphQL/data-type-aggegate-GQL.response';
import * as lodash from 'lodash';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class FakeServiceService {
  newDataTypeCollection: DatatypeTreeHierarchi = new DatatypeTreeHierarchi();
  constructor(private http: HttpClient,
    private loginService: LoginService) { }

  public getFactoriesData(): Observable<any> {
    return this.http.get(environment.assetsDataPath + 'tablaLastMeasurements.json');
  }

  public getLanguagesData(): Observable<any> {
    return this.http.get(environment.assetsDataPath + 'idiomas.json');
  }

  public getDispositivosData(): Observable<any> {
    return this.http.get(environment.assetsDataPath + 'dispositivos.json');
  }

  public getDeviceLabelsMapping(): Observable<any> {
    return this.http.get(environment.assetsDataPath + 'deviceLabelsMapping.json');
  }

  public getDataType(): Observable<DatatypeTreeHierarchi[]> {
     return this.http.get<DataTypeAggregateGraphQlResponse>(environment.assetsDataPath + 'datatype.json').pipe(
      map(item =>{
        const allDataTypeReversedCollection =   item.findTipoDatos.map(item => this.findRoot(item.agrupacion[0],DataTypeMapper.dataTypeDetailAggregateGQlResponseToDataTypeItem(item, this.loginService.currentUserValue.language)));
        const allDataTypeGruped: DatatypeTreeHierarchi[]=[]
        allDataTypeReversedCollection.forEach(rootItem => 
          {
            const rootGrouped = allDataTypeGruped.firstOrDefault(item => item.root.uuid === rootItem.uuid);
            if(lodash.isEmpty(rootGrouped)){
              const newRoot:DatatypeTreeHierarchi = new DatatypeTreeHierarchi();
              newRoot.root = rootItem;
              allDataTypeGruped.push(newRoot);
            }else{
              rootGrouped.addChildren(rootItem.children);
            }
          });
        return allDataTypeGruped;
      }
    )); 
  }

  execTest() {
    this.getDataType().subscribe(result => {
  });
    }

  findRoot(arr: DataTypeGroupGraphQlResponse,children:DataGroup|DataTypeItem): DataGroup {
    if(arr === null || arr === undefined)
    {
      const orphan = Object.assign(new DataGroup(),{uuid:"-99",name:"Tipo de dato sin agrupar"});
      orphan.addChild(children);
      return orphan;
    }
    const newDataType =  DataTypeMapper.dataTypeAggregateGQLResToDataGroup(arr, this.loginService.currentUserValue.language);
    if (!lodash.isEmpty(arr.agrupacion)) {
      const parent :DataGroup =  this.findRoot(arr.agrupacion[0],newDataType);
      newDataType.addChild(children);
      return parent;
    }
    newDataType.addChild(children);
    return newDataType;
  }

}
